import { QueryHookOptions } from "@apollo/client";
import { PortfolioPerformanceGraphQuery, PortfolioPerformanceGraphQueryVariables } from "@ctypes";
import { PORTFOLIO_PERFORMANCE_GRAPH } from "@graphql";
import { useQuery } from "@hooks/apollo";

export const usePortfolioPerformanceGraph = (
  options?: QueryHookOptions<
    PortfolioPerformanceGraphQuery,
    PortfolioPerformanceGraphQueryVariables
  >,
) => {
  return useQuery<PortfolioPerformanceGraphQuery, PortfolioPerformanceGraphQueryVariables>(
    PORTFOLIO_PERFORMANCE_GRAPH,
    {
      fetchPolicy: "cache-and-network",
      ...options,
    },
  );
};
